import VesselSVGMarkup from "../markerIcons/VesselSVGMarkup";


const Marker = ({
    markerColor = "cyan",
    iconDirection = 0,
    vesselType,
    handleOnMarkerClick,
    isMarkerChecked,
    iconUrl = null
}) => {

    // console.log("============iconUrl============", iconUrl) 
    return (
        <div className="min-w-[27px] min-h-[27px] bg-blue-100 rounded-xl flex items-center justify-center overflow-hidden">
            {iconUrl ? (
                <img
                    src={iconUrl}
                    alt="vessel-marker"
                    className="w-[27px] h-[27px]"
                    onClick={() => handleOnMarkerClick()}
                />
            ) : (
                <VesselSVGMarkup
                    color={markerColor}
                    iconDirection={iconDirection}
                    vesselType={vesselType}
                    handleOnMarkerClick={handleOnMarkerClick}
                    isMarkerChecked={isMarkerChecked}
                />
            )}
        </div>
    )
};
export default Marker